import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormHelperText, makeStyles, Typography } from '@material-ui/core';
import InputField from '../../inputField';
import TextBoxWithTooltip from '../../textBoxWithTooltip';

const useStyles = makeStyles(({ spacing }) => ({
  errorMessage: {
    position: 'absolute',
    bottom: -20,
  },
  input: {
    fontFamily: 'ProximaNova-Bold',
    flexWrap: 'nowrap',
  },
  currency: {
    marginRight: spacing(2.75),
  },
  fieldWrapper: {
    display: 'grid',
    gap: spacing(4),
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
  salarySubtitle: {
    paddingTop: spacing(4),
    paddingBottom: spacing(4),
  },
}));

const SalaryRange = ({
  translations,
  id,
  currency = '',
  value,
  fieldTypes,
  error = null,
  onChange,
}) => {
  const classes = useStyles();
  const [minSalaryField, maxSalaryField] = fieldTypes;

  const handleChangeText = useCallback(
    (e, name) => {
      onChange(
        {
          ...value,
          [name]: e.target.value === '' ? null : Number(e.target.value),
        },
        id
      );
    },
    [id, value, onChange]
  );

  return (
    <div>
      {value?.name && (
        <TextBoxWithTooltip
          variant="subtitle1"
          className={classes.salarySubtitle}
          text={value.name}
        />
      )}
      <div className={classes.fieldWrapper}>
        <div>
          <FormHelperText>
            {translations[minSalaryField.translationKey].label}
          </FormHelperText>
          <InputField
            customRootClass={classes.input}
            customErrorClass={classes.errorMessage}
            id={minSalaryField.name}
            name={minSalaryField.name}
            type={minSalaryField.type}
            placeholder={
              translations[minSalaryField.translationKey].placeholder
            }
            required={minSalaryField.required}
            value={
              value?.[minSalaryField.name] === null
                ? ''
                : value?.[minSalaryField.name]
            }
            error={!!error?.[minSalaryField.name]}
            errorMessage={
              translations.validationMessages?.[error?.[minSalaryField.name]]
            }
            startAdornment={
              <Typography className={classes.currency}>{currency}</Typography>
            }
            onChange={e => handleChangeText(e, minSalaryField.name)}
            fullWidth
          />
        </div>
        <div>
          <FormHelperText>
            {translations[maxSalaryField.translationKey].label}
          </FormHelperText>
          <InputField
            customRootClass={classes.input}
            customErrorClass={classes.errorMessage}
            id={maxSalaryField.name}
            name={maxSalaryField.name}
            type={maxSalaryField.type}
            placeholder={
              translations[maxSalaryField.translationKey].placeholder
            }
            required={maxSalaryField.required}
            value={
              value?.[maxSalaryField.name] === null
                ? ''
                : value?.[maxSalaryField.name]
            }
            error={!!error?.[maxSalaryField.name]}
            errorMessage={
              translations.validationMessages?.[error?.[maxSalaryField.name]]
            }
            startAdornment={
              <Typography className={classes.currency}>{currency}</Typography>
            }
            onChange={e => handleChangeText(e, maxSalaryField.name)}
            fullWidth
          />
        </div>
      </div>
    </div>
  );
};

SalaryRange.propTypes = {
  translations: PropTypes.object.isRequired,
  id: PropTypes.number.isRequired,
  currency: PropTypes.string,
  value: PropTypes.object.isRequired,
  fieldTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  error: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default SalaryRange;
